import * as Husleieapi from '@modules/husleieapi';

export default {
  data() {
    return {
      hlValidationRules: null,
      hlValidationRegexpRules: null,
    };
  },
  methods: {
    hlFetchValidationRules(form_name) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vue = this;
      const validation = new Husleieapi.ValidationApi();

      validation.validateRules(form_name, (error, data) => {
        if (error) {
          throw new Error(`Failed getting validation rules for ${form_name}`);
        } else {
          const named = {};
          const regex = {};
          for (const r in data) {
            if (data[r].type === 'regex') {
              regex[data[r].name] = data[r].rule;
            } else {
              named[data[r].name] = data[r].rule;
            }
          }
          vue.hlValidationRules = named;
          vue.hlValidationRegexRules = regex;
        }
      });
    },
  },
};
